import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './Button';

const ORG_REPO = 'https://github.com/Agents2AgentsAI';

/* Past this depth the bar compacts on the way down and reopens on the way up.
   The compaction is drawn by a pseudo-element and a transform, so the document
   below the nav never moves. */
const COMPACT_AT = 120;

export function SiteNav() {
    const [scrolled, setScrolled] = React.useState(false);
    const [compact, setCompact] = React.useState(false);
    const { pathname } = useLocation();
    const onBlog = pathname.startsWith('/blog');
    const onManifesto = pathname === '/manifesto';

    React.useEffect(() => {
        let last = window.scrollY;
        const onScroll = () => {
            const y = window.scrollY;
            setScrolled(y > 8);
            if (y < COMPACT_AT) setCompact(false);
            else if (Math.abs(y - last) > 6) setCompact(y > last);
            last = y;
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <header
            className={['ds-nav', scrolled ? 'ds-nav--scrolled' : '', compact ? 'ds-nav--compact' : '']
                .filter(Boolean)
                .join(' ')}
        >
            <div className="ds-nav__inner">
                <Link to="/" className="ds-nav__brand">
                    <img src="/brand/mark-glyph-96.png" alt="" />
                    <span className="ds-nav__word">Agents2Agents</span>
                </Link>
                <nav className="ds-nav__links">
                    <Link to="/manifesto" className={['ds-nav__link', onManifesto ? 'ds-nav__link--active' : ''].filter(Boolean).join(' ')}>
                        manifesto
                    </Link>
                    <Link to="/blog" className={['ds-nav__link', onBlog ? 'ds-nav__link--active' : ''].filter(Boolean).join(' ')}>
                        blog
                    </Link>
                    <a className="ds-nav__link" href={ORG_REPO} target="_blank" rel="noreferrer">
                        GitHub
                    </a>
                    <Button to="/blog" size="md" pill>
                        Read the blog
                    </Button>
                </nav>
            </div>
        </header>
    );
}
